import { render, staticRenderFns } from "./sharePageTwo.vue?vue&type=template&id=39acb95e&scoped=true&"
import script from "./sharePageTwo.vue?vue&type=script&lang=js&"
export * from "./sharePageTwo.vue?vue&type=script&lang=js&"
import style0 from "./sharePageTwo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sharePageTwo.vue?vue&type=style&index=1&id=39acb95e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39acb95e",
  null
  
)

export default component.exports